const CONTROLLED_LOGOUT = 'CONTROLLED_LOGOUT',
  LAST_API_CALL = 'lastApiCall',
  TOKEN_REFRESHED = 'tokenRefreshed',
  PUBLIC_SITE_CHAT = 'publicSiteChat',
  IS_CUSTOMER = 'isCustomer',
  PUBLIC_DOMAIN = 'kunden.openbankpay.com',
  URL_PUBLIC_CHAT_OPI = 'urlPublicChatOpi',
  URL_PUBLIC_CHAT_SURVEY = 'urlPublicChatSurvey',
  REFRESH_TIMER = 300000;

export {
  CONTROLLED_LOGOUT,
  IS_CUSTOMER,
  PUBLIC_SITE_CHAT,
  LAST_API_CALL,
  REFRESH_TIMER,
  TOKEN_REFRESHED,
  PUBLIC_DOMAIN,
  URL_PUBLIC_CHAT_OPI,
  URL_PUBLIC_CHAT_SURVEY,
};
